import { BoxProps } from '@chakra-ui/react';
import React from 'react';

import { CmBox } from '..';

export const CmSeparate: React.FC<BoxProps> = ({
  height = '25px',
  ...rest
}): JSX.Element => {
  return <CmBox width="1px" {...{ height, ...rest }} bg="black" />;
};
